import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import PDPProtectionPlanSelector from 'components/consumer/PDP/PDPProtectionPlanSelector';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPDesktopGalleryRevamp from '../PDPDesktopGalleryRevamp';
import PDPDesktopHeroGallery from '../PDPDesktopHeroGallery';
import { PDPDesktopGalleryHoldFallback } from '../PDPDesktopPhotoPanel';
import useIsGalleryRevampVariant from '../useIsGalleryRevampVariant';
import PDPKeySellingPoints from '../PDPKeySellingPoints';
import PDPNameSection from '../PDPNameSection';
import PDPShopTabsBar from '../PDPShopTabsBar';
import PDPOnDisplayInShowroom from '../PDPOnDisplayInShowroom';
import PDPAddToBagSection from '../PDPAddToBagSection';
import PDPUpSellProduct from '../PDPUpSellProduct';
import PDPCustomerPhotos from '../PDPCustomerPhotos';
import PDPBreadCrumbs from '../PDPBreadCrumbs';
import PDPAlertBar from '../PDPAlertBar';
import PDPAlertsSection from '../PDPAlertsSection';
import PDPDiscontinuedMessage from '../PDPDiscontinuedMessage';
import PDPChooseYourOptions from '../PDPChooseYourOptions';
import PDPGalleryLabels from '../PDPGalleryLabels';
import PDPInfoTabs from '../PDPInfoTabs';
import PDPStickySummaryBar from '../PDPStickySummaryBar';
import PDPSectionDivider from '../PDPSectionDivider';
import PDPCuralateGallery from '../PDPFooter/PDPCuralateGallery';
import { PDPRecentlyViewed } from '../PDPFooter';
const PDPCollectionSlider = loadable(() => import('../PDPCollectionSlider'));
const PDPDesktopRevamp = t0 => {
  const $ = _c(70);
  const {
    discontinuedCategoryMsg: t1,
    isOutOfStock: t2,
    showDiscontinuedNotification: t3,
    showOutOfStockNotification: t4,
    slug,
    productHeroImage: t5,
    productCylindoHeroImage: t6
  } = t0;
  const discontinuedCategoryMsg = t1 === undefined ? null : t1;
  const isOutOfStock = t2 === undefined ? false : t2;
  const showDiscontinuedNotification = t3 === undefined ? false : t3;
  let t7;
  if ($[0] !== t4) {
    t7 = t4 === undefined ? {} : t4;
    $[0] = t4;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const showOutOfStockNotification = t7;
  const productHeroImage = t5 === undefined ? null : t5;
  const productCylindoHeroImage = t6 === undefined ? null : t6;
  const isGalleryRevampVariant = useIsGalleryRevampVariant();
  const [displayPressComp, setDisplayPressComp] = useState(false);
  let t8;
  if ($[2] !== productCylindoHeroImage || $[3] !== slug) {
    t8 = <PDPStickySummaryBar slug={slug} productCylindoHeroImage={productCylindoHeroImage} />;
    $[2] = productCylindoHeroImage;
    $[3] = slug;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t10;
  let t11;
  let t12;
  let t9;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="mt-10 -mb-8"><PDPGalleryLabels /></div>;
    t10 = <PDPNameSection disableStickyPriceRow={true} hideProductLabel={true} hideRatings={true} />;
    t11 = <PDPOnDisplayInShowroom />;
    t12 = <hr className="border-0 border-t border-gray-light7 my-6" />;
    $[5] = t10;
    $[6] = t11;
    $[7] = t12;
    $[8] = t9;
  } else {
    t10 = $[5];
    t11 = $[6];
    t12 = $[7];
    t9 = $[8];
  }
  let t13;
  if ($[9] !== discontinuedCategoryMsg || $[10] !== showDiscontinuedNotification) {
    t13 = showDiscontinuedNotification ? <PDPAlertBar type="error"><PDPDiscontinuedMessage discontinuedCategoryMsg={discontinuedCategoryMsg} /></PDPAlertBar> : <div className="PDPDesktop__PDPAlertBar-filler" />;
    $[9] = discontinuedCategoryMsg;
    $[10] = showDiscontinuedNotification;
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  let t14;
  if ($[12] !== isOutOfStock || $[13] !== showDiscontinuedNotification) {
    t14 = !isOutOfStock && !showDiscontinuedNotification ? <div className="PDPDesktop__in-stock-options"><PDPShopTabsBar hideDecideLaterTab={true} isLayoutRevamp={true} /><PDPChooseYourOptions isLayoutRevamp={true} /><PDPProtectionPlanSelector isLayoutRevamp={true} /></div> : <div className="PDPDesktop__in-stock-options-filler" />;
    $[12] = isOutOfStock;
    $[13] = showDiscontinuedNotification;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] !== isOutOfStock || $[16] !== showDiscontinuedNotification || $[17] !== showOutOfStockNotification) {
    t15 = isOutOfStock && !showDiscontinuedNotification ? <PDPAlertsSection showOutOfStockNotification={showOutOfStockNotification} /> : <div className="PDPDesktop__PDPAlertSection-filler" />;
    $[15] = isOutOfStock;
    $[16] = showDiscontinuedNotification;
    $[17] = showOutOfStockNotification;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] !== showDiscontinuedNotification) {
    t16 = !showDiscontinuedNotification && <hr className="border-0 border-t border-gray-light7 my-6" />;
    $[19] = showDiscontinuedNotification;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== isOutOfStock) {
    t17 = <PDPAddToBagSection isOutOfStock={isOutOfStock} />;
    $[21] = isOutOfStock;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== isOutOfStock || $[24] !== showDiscontinuedNotification) {
    t18 = !isOutOfStock && !showDiscontinuedNotification ? <PDPUpSellProduct /> : <div className="PDPDesktopRevamp__add-ons-filler" />;
    $[23] = isOutOfStock;
    $[24] = showDiscontinuedNotification;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] !== t13 || $[27] !== t14 || $[28] !== t15 || $[29] !== t16 || $[30] !== t17 || $[31] !== t18) {
    t19 = <div className="flex-none min-w-[460px] w-[460px] [@media(width:1024px)]:min-w-[400px] [@media(width:1024px)]:w-[400px]">{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}</div>;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="min-h-[66px]"><PDPBreadCrumbs /></div>;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <PDPDesktopGalleryHoldFallback tag="panel" />;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  const t22 = isGalleryRevampVariant ? "revamp" : "gallery";
  let t23;
  if ($[35] !== t22) {
    t23 = <PDPDesktopGalleryHoldFallback tag={t22} />;
    $[35] = t22;
    $[36] = t23;
  } else {
    t23 = $[36];
  }
  let t24;
  if ($[37] !== isGalleryRevampVariant || $[38] !== productCylindoHeroImage || $[39] !== productHeroImage || $[40] !== slug) {
    t24 = isGalleryRevampVariant ? <PDPDesktopGalleryRevamp slug={slug} productHeroImage={productHeroImage} productCylindoHeroImage={productCylindoHeroImage} hideProductLabel={true} /> : <PDPDesktopHeroGallery slug={slug} productHeroImage={productHeroImage} productCylindoHeroImage={productCylindoHeroImage} hideProductLabel={true} />;
    $[37] = isGalleryRevampVariant;
    $[38] = productCylindoHeroImage;
    $[39] = productHeroImage;
    $[40] = slug;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== t23 || $[43] !== t24) {
    t25 = <SuspenseWithLoader fallback={t23}>{t24}</SuspenseWithLoader>;
    $[42] = t23;
    $[43] = t24;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <SuspenseWithLoader fallback={<PDPDesktopGalleryHoldFallback tag="ksp" />}><PDPKeySellingPoints /></SuspenseWithLoader>;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] !== t25) {
    t27 = <SuspenseWithLoader fallback={t21}>{t25}{t26}</SuspenseWithLoader>;
    $[46] = t25;
    $[47] = t27;
  } else {
    t27 = $[47];
  }
  let t28;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <PDPInfoTabs />;
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  let t29;
  if ($[49] !== t27) {
    t29 = <div className="flex-1 mr-12 min-w-0 isolate">{t20}{t27}{t28}</div>;
    $[49] = t27;
    $[50] = t29;
  } else {
    t29 = $[50];
  }
  let t30;
  if ($[51] !== t19 || $[52] !== t29) {
    t30 = <FixedWidthContainer wide={true} className="relative z-10 flex flex-row-reverse !pt-2 !pb-8">{t19}{t29}</FixedWidthContainer>;
    $[51] = t19;
    $[52] = t29;
    $[53] = t30;
  } else {
    t30 = $[53];
  }
  let t31;
  if ($[54] !== displayPressComp) {
    t31 = !displayPressComp ? <><PDPSectionDivider className="my-12" /><SuspenseWithLoader><PDPCollectionSlider setDisplayPressComp={setDisplayPressComp} isLayoutRevamp={true} /></SuspenseWithLoader></> : <div className="PDPDesktop__PDPPress-filler" />;
    $[54] = displayPressComp;
    $[55] = t31;
  } else {
    t31 = $[55];
  }
  let t32;
  let t33;
  let t34;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <PDPSectionDivider className="my-12" />;
    t33 = <PDPCuralateGallery isLayoutRevamp={true} />;
    t34 = <PDPSectionDivider className="my-12" />;
    $[56] = t32;
    $[57] = t33;
    $[58] = t34;
  } else {
    t32 = $[56];
    t33 = $[57];
    t34 = $[58];
  }
  let t35;
  if ($[59] !== slug) {
    t35 = <PDPCustomerPhotos slug={slug} isLayoutRevamp={true} />;
    $[59] = slug;
    $[60] = t35;
  } else {
    t35 = $[60];
  }
  let t36;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <PDPSectionDivider className="my-12" />;
    $[61] = t36;
  } else {
    t36 = $[61];
  }
  let t37;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <SuspenseWithLoader><PDPRecentlyViewed isLayoutRevamp={true} /></SuspenseWithLoader>;
    $[62] = t37;
  } else {
    t37 = $[62];
  }
  let t38;
  if ($[63] !== t31 || $[64] !== t35) {
    t38 = <FixedWidthContainer wide={true} className="!pt-0 !pb-8">{t31}{t32}{t33}{t34}{t35}{t36}{t37}</FixedWidthContainer>;
    $[63] = t31;
    $[64] = t35;
    $[65] = t38;
  } else {
    t38 = $[65];
  }
  let t39;
  if ($[66] !== t30 || $[67] !== t38 || $[68] !== t8) {
    t39 = <div className="max-[1023px]:hidden" data-xc="PDPDesktopRevamp">{t8}{t30}{t38}</div>;
    $[66] = t30;
    $[67] = t38;
    $[68] = t8;
    $[69] = t39;
  } else {
    t39 = $[69];
  }
  return t39;
};
PDPDesktopRevamp.propTypes = {
  discontinuedCategoryMsg: PropTypes.shape({
    category: PropTypes.string,
    link: PropTypes.string
  }),
  isOutOfStock: PropTypes.bool,
  showDiscontinuedNotification: PropTypes.bool,
  showOutOfStockNotification: PropTypes.shape({
    productId: PropTypes.number,
    show: PropTypes.bool
  }),
  slug: PropTypes.string,
  productHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  }),
  productCylindoHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  })
};
export default PDPDesktopRevamp;